import React from "react"
import styled from "@emotion/styled"
import { css } from "@emotion/react"
import Section from "src/components/Section"
import Grid from "src/components/Grid"
import { mq, typography, colors, globals, util } from "src/styles"
import ScrollEntrance from "src/components/ScrollEntrance"
import Marketo from "src/components/Marketo"
import Image from "src/components/Image"
import SanityRichText from "src/components/SanityRichText"
import {
  ReviewMeta,
  ThumbnailWrapper,
  renderRating,
  ReviewImage,
} from "src/components/Reviews"

const Wrapper = styled(Section)`
  ${({ vertical }) =>
    `
    ${globals.verticalSpacing("padding-top", vertical)}
    ${globals.verticalSpacing("padding-bottom", vertical)}
    `}
  ${({ horizontal }) =>
    `
    ${globals.verticalSpacing("padding-left", horizontal)}
    ${globals.verticalSpacing("padding-right", horizontal)}
  `}
  ${mq.mediumAndBelow} {
    ${({ hideMobile }) => hideMobile && "display: none"}
  }
  ${mq.largeAndUp} {
    ${({ hideDesktop }) => hideDesktop && "display: none"}
  }
`

const Headline = styled.h1`
  margin: 0 0 0.5em;
`

const FormWrapper = styled.div`
  ${util.responsiveStyles("padding", 60, 40, 24, 20)}
  background: ${colors.lightGrey};
  border-radius: ${globals.cardBorderRadius};
`

const ReviewCard = styled(globals.Card)``

const CardMediaWrapper = styled.div`
  .gatsby-image-wrapper,
  .gatsby-image-wrapper img {
    overflow: hidden;
    border-radius: var(--card-border-radius) var(--card-border-radius) 0 0;
  }
`

const OfferKoalafi = ({
  className,
  nextTheme,
  prevTheme,
  theme,
  spacing,
  isFirstSection,
  headingSize,
  headline,
  script,
  formId,
  baseUrl,
  munchkinId,
  _rawText,
  cardImage,
  cardReview,
  id,
  hideMobile,
  hideDesktop,
}) => {
  return (
    <Wrapper
      className={className}
      prevTheme={prevTheme}
      setTheme={theme}
      nextTheme={nextTheme}
      isFirstSection={isFirstSection}
      id={id}
      vertical={spacing?.vertical}
      horizontal={spacing?.horizontal}
      hideMobile={hideMobile}
      hideDesktop={hideDesktop}
    >
      <Grid
        small="m [1] m"
        medium="1 [12] 1"
        large="1 [6] 1 [5] 1"
        larger="1 [6] 1 [4] 2"
        rowGap="30px"
        vAlign="top"
        as={ScrollEntrance}
      >
        <div>
          {headline && (
            <Headline className={headingSize ? headingSize : "h3"}>
              {headline}
            </Headline>
          )}
          <FormWrapper>
            <Marketo
              node={{
                script: script,
                baseUrl: baseUrl,
                munchkinId: munchkinId,
                formId: formId,
                inputStyle: "default",
              }}
            />
          </FormWrapper>
        </div>
        <div>
          <Grid
            small="[1]"
            medium="[1] [1]"
            large="[1]"
            colGap="50px"
            vAlign="top"
            rowGap={["26px", "32px", "36px"]}
          >
            <div>
              <SanityRichText text={_rawText} />
            </div>
            <div>
              <ReviewCard>
                {cardImage?.asset?.gatsbyImageData && (
                  <CardMediaWrapper>
                    <Image
                      ratio={9 / 16}
                      image={cardImage.asset.gatsbyImageData}
                    />
                  </CardMediaWrapper>
                )}
                <div
                  css={css`
                    padding: 20px;
                  `}
                >
                  <p
                    css={css`
                    ${typography.bodyLarge}
                    font-weight: ${typography.bold};
                    color: ${colors.textColor};
                    margin: -.1em 0 1em 0;
                  `}
                  >
                    {cardReview.reviewText}
                  </p>
                  <ReviewMeta>
                    <div>
                      {cardReview.title && (
                        <p style={{ color: colors.textColor }}>
                          {cardReview.title}
                        </p>
                      )}
                      {cardReview.subtitle && (
                        <p style={{ color: colors.lightTextColor }}>
                          {cardReview.subtitle}
                        </p>
                      )}
                      {renderRating(cardReview.rating)}
                    </div>
                    {cardReview?.thumbnail?.asset?.gatsbyImageData && (
                      <ThumbnailWrapper>
                        <ReviewImage
                          image={cardReview?.thumbnail?.asset?.gatsbyImageData}
                          ratio={1}
                        />
                      </ThumbnailWrapper>
                    )}
                  </ReviewMeta>
                </div>
              </ReviewCard>
            </div>
          </Grid>
        </div>
      </Grid>
    </Wrapper>
  )
}

export default OfferKoalafi
